import * as React from 'react'
import { compose, pure } from 'recompose'

import LargeTitle, { SizeType } from '../../atoms/LargeTitle/LargeTitle'
import TextField from '../../atoms/TextField/TextField'
import TextLabel, { ColorType, SizeType as labelSize, WeightType } from '../../atoms/TextLabel/TextLabel'

import * as styles from './NameInputForm.css'

interface NameInputFormProps {
  handleChange: (text: string) => void
}

const NameInputForm: React.FunctionComponent<NameInputFormProps> = ({ handleChange }) => (
  <div>
    <div className={styles.title}>
      <LargeTitle size={SizeType.SMALL}>名前を入力してください</LargeTitle>
    </div>
    <div className={styles.notice}>
      <TextLabel color={ColorType.BASE} weight={WeightType.LIGHT} size={labelSize.LARGE}>
        結果発表のときに他の参加者にあなたであることが分かる名前を記入してください
      </TextLabel>
    </div>
    <TextField id="signup-name" handleChange={handleChange} placeholder="全角20文字まで" />
  </div>
)

export default compose<NameInputFormProps, NameInputFormProps>(pure)(NameInputForm)
